<template>
	<b-tr>
		<th scope="row">Profession
			<input class="form-control form-control-sm" v-model="name" />
		</th>
		<!--<th scope="row">
			Profession
			<input type="text" class="form-control form-control-sm" />
		</th>-->
		<td class="table-active">{{total}}</td>
		<td><input disabled class="form-control form-control-sm disabled" type="number" :value="ranks"/></td>
		<td class="form-inline">
			<div class="input-group input-group-sm">
				<input readonly type="number" class="form-control form-control-sm" v-model="abilityMods[ability]" />
				<select class="form-control form-control-sm" style="max-width:4.75em; width:4.75em;" v-model="ability">
					<option value="Strength">STR</option>
					<option value="Dexterity">DEX</option>
					<option value="Constitution">CON</option>
					<option value="Intelligence">INT</option>
					<option value="Wisdom">WIS</option>
					<option value="Charisma">CHA</option>
				</select>
			</div>
		</td>
		<td><input class="" type="checkbox" v-model="class_skill"></td>
		<td><input class="form-control form-control-sm" type="number" step="1" v-model="insight" /></td>
		<td><input class="form-control form-control-sm" type="number" step="1" v-model="race" /></td>
		<td><input class="form-control form-control-sm" type="number" step="1" v-model="theme" /></td>
		<td><input class="form-control form-control-sm" type="number" step="1" v-model="misc" /></td>
	</b-tr>
</template>

<script>
function mapProps( mod, properties ){
	var computed = {}
	properties.forEach(property => {
		computed[property] = {
			get () {
				return this.$store.getters[`${mod}/getProfession`](this.profession,property)
			},
			set ( value ){
				this.$store.commit(`${mod}/setProfession`,{
					profession: this.profession,
					property,
					value
				})
			}
		}
	})
	return computed
}
function mapBonuses( mod, properties ){
	var computed = {}
	properties.forEach(property => {
		computed[property] = {
			get () {
				return this.$store.getters[`${mod}/getProfessionBonus`](this.profession,property)
			},
			set ( value ){
				this.$store.commit(`${mod}/setProfessionBonus`,{
					profession: this.profession,
					property,
					value
				})
			}
		}
	})
	return computed
}
export default {
	props: [
		'profession',
	],
	computed: {
		abilityMods: function() {
			return this.$store.getters['character/abilityScores/abilityMods']
		},
		total: function() {
			return this.$store.getters['character/skills/total'][this.skill]
		},
		ranks: function() {
			return this.$store.getters['character/skills/ranks'][this.skill]
		},
		...mapProps('character/skills', [
			'name',
			'ability',
			'class_skill',
		]),
		...mapBonuses('character/skills', [
			'insight',
			'race',
			'theme',
			'misc'
		])
	},
	methods:{
		formatTitle(title) {
			return this.$store.getters['formatTitle'](title)
		}
	}
	
}
</script>

<style scoped>

</style>